import React from 'react';
import PropTypes from 'prop-types';
import { isType, flattenChildren } from '../../../../utils/react-children-utils/react-children-utils';
import ControlP from '../../../atoms/control/ControlP';
import SubmitButton from '../../../atoms/submit-button/index.ts';
import styles from './styles.scss';
import InputContainer from '../../../atoms/inputs/input-container';
import { initFieldIsValids } from '../../../../utils/form-utils';
import HalfWidthControlP from '../../../atoms/half-width-control/HalfWidthControlP';

class StripeSignupForm extends React.Component {
    constructor(props) {
        super(props);

        this.setFieldState = this.setFieldState.bind(this);
        this.handleHalfWidthContainer = this.handleHalfWidthContainer.bind(this);
        this.getControl = this.getControl.bind(this);
        this.getSpecialControl = this.getSpecialControl.bind(this);
        this.getTypicalControl = this.getTypicalControl.bind(this);

        const formControls = flattenChildren(props.children)
            .filter((c) => isType(c, 'ControlP') || isType(c, 'HalfWidthControlP'));

        const fieldIsValids = initFieldIsValids(formControls);

        this.state = {
            fieldIsValids,
        };
    }

    handleHalfWidthContainer(inputContainer, label) {
        const { required } = inputContainer.props;
        const newContainer = React.cloneElement(
            inputContainer,
            {
                passerror: this.setFieldState,
                required,
            },
        );

        return (
            <HalfWidthControlP key={`${inputContainer.props.name}-control`}>
                {label}
                {newContainer}
            </HalfWidthControlP>
        );
    }

    getControl(control) {
        const currentControl = control;

        // Children of the ControlP and not this component.
        const controlChildren = flattenChildren(currentControl.props.children);

        const label = controlChildren.find((c) => isType(c, 'InputLabel'));
        const inputContainer = controlChildren.find((c) => isType(c, 'InputContainer'));

        const input = controlChildren.find((c) => isType(c, 'input'));

        if (isType(currentControl, 'ControlP') && input) { // We may have HalfWidthControlP
            return this.getTypicalControl(
                inputContainer,
                label,
            );
        }

        return this.getSpecialControl(
            control,
            inputContainer,
            label,
        );
    }

    getSpecialControl(control, inputContainer, label) {
        const inputName = inputContainer.props.name;

        let newControl = control;

        // Set rendering extras e.g. options and HalfWidthControlP's on the left etc...
        if (control.type.name === 'HalfWidthControlP') {
            newControl = this.handleHalfWidthContainer(inputContainer, label);
        } else {
            newControl = this.getTypicalControl(inputContainer, label);
        }

        if (inputName === 'firstname' || inputName === 'state') {
            return (
                <div className={styles['half-width-left']} key={`${inputName}-control`}>
                    {newControl}
                </div>
            );
        }

        return newControl;
    }

    getTypicalControl(inputContainer, label) {
        const inputs = inputContainer.props.children;

        return (
            <ControlP key={`${inputContainer.props.name}-control`}>
                {label}
                <InputContainer
                    passerror={this.setFieldState}
                    name={inputContainer.props.name}
                    displayname={inputContainer.props.displayname}
                    required={inputContainer.props.required}
                >
                    {inputs}
                </InputContainer>
            </ControlP>
        );
    }

    setFieldState(fieldName, error) {
        const { fieldIsValids } = this.state;

        const newFields = fieldIsValids;
        newFields[fieldName] = !error;

        this.setState(() => ({
            fieldIsValids: newFields,
        }));
    }

    render() {
        const { children } = this.props;
        const { fieldIsValids } = this.state;
        const invalid = Object.values(fieldIsValids).filter((c) => !c).length > 0;

        const controls = flattenChildren(children)
            .filter((c) => isType(c, 'ControlP') || isType(c, 'HalfWidthControlP'))
            .map((c) => this.getControl(c));

        return (
            <div className={styles['stripe-signup-form']}>
                <form action="CreateStripe" method="post">
                    {controls}
                    <div className="columns is-centered">
                        <div className="column is-narrow">
                            <div className="control mt-4">
                                <SubmitButton isdisabled={invalid} name="stripe-submit" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

StripeSignupForm.propTypes = {
    children: PropTypes.node.isRequired,
};

StripeSignupForm.defaultProps = {
};

export default StripeSignupForm;
